import BoardItem from './BoardItem';

class Board {
  id: number;
  groupId: number;
  orderInGroup: number;
  title: string = '';
  items: BoardItem[] = [];
  created: number;
  updated: number;
}

export default Board;



// WEBPACK FOOTER //
// ./src/entities/Board.ts